import { Injectable } from '@angular/core';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadPdfService {
  constructor(private readonly appService: AppService) {}
  
  downloadPdf(base64Data: string, fileName: string, fileType: string): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        const url = URL.createObjectURL(blob);
        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = fileName;
        document.body.appendChild(anchorElement);
        anchorElement.click();
        
        URL.revokeObjectURL(url);
        document.body.removeChild(anchorElement);
  
        resolve(); 
      } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        this.appService.handleErrorMessage(errorMessage);
        reject(new Error(errorMessage));
      }
    });
  }
}
